import api from "../../http";

export default class ApiSlotMachinesMain {
  static async getApiSlotMachinesMain(url) {
    return api.get(url)
  }
}